/* Medivital Detox 2.0 landing: saját csomagválasztó (Kaching nélkül), 1 / 2 / 3 csomag.
   - A blokkot a termékblokkba, a kosárgomb fölé teszi.
   - Kosárba tétel: /cart/add.js (a termék változata × csomagszám), utána a téma kosara (UpCart / cart drawer).
     A 2 és 3 csomagos árat a Shopify automatikus kedvezménye adja a kosárban.
   - A téma formját (változat + mennyiség) szinkronban tartja, hogy a gyors fizetés (GPay) és az utánvét gomb is a választott darabszámot vegye.
   - A záró ajánlat gombja ("Kérem a 30 éjszakás csomagot") a beállított csomagot jelöli ki.
   A tarkólazító (mv-lp-bundle-tarkolazito.js) mintájára. Csak a landing-detox sablonon töltődik be. */
(function () {
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function productForm() {
    var pf = qs('.product__info-container product-form') || qs('product-form');
    return pf ? { el: pf, form: pf.querySelector('form') } : null;
  }

  function state(box) {
    var card = qs('.mvlpb__card.is-selected', box) || qs('.mvlpb__card', box);
    return { card: card, id: +box.dataset.variant, qty: +(card && card.dataset.qty) || 1 };
  }

  function syncForm(box) {
    var st = state(box), pf = productForm(); if (!pf || !pf.form) return;
    var idIn = pf.form.querySelector('input[name="id"]');
    if (idIn && st.id) idIn.value = st.id;
    var fid = pf.form.getAttribute('id');
    var qty = (fid && document.querySelector('input[name="quantity"][form="' + fid + '"]')) || pf.form.querySelector('input[name="quantity"]');
    if (qty) qty.value = st.qty;
    var btn = pf.el.querySelector('.product-form__submit');
    if (btn && !btn.disabled) {
      var span = btn.querySelector('span') || btn;
      span.textContent = (box.dataset.button || 'Kosárba') + ' — ' + st.card.dataset.total;
    }
    document.dispatchEvent(new CustomEvent('mvlpb:change'));
  }

  function select(box, card) {
    qsa('.mvlpb__card', box).forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    syncForm(box);
  }

  function showError(pf, msg) {
    var w = pf.el.querySelector('.product-form__error-message-wrapper');
    var m = w && w.querySelector('.product-form__error-message');
    if (!w || !m) { if (msg) alert(msg); return; }
    w.toggleAttribute('hidden', !msg);
    if (msg) m.textContent = msg;
  }

  function hasUpcart() {
    return typeof window.upcartOpenCart === 'function' || (document.body && document.body.dataset.upcartCartEnabled === 'true');
  }

  /* biztonsági háló: ha az UpCart bezárul, a téma rejtett cart-drawere és a body görgetési zára ne maradjon bent */
  function releaseThemeLock() {
    setTimeout(function () {
      if (document.body.classList.contains('upcartPopupShow')) return;
      var d = document.querySelector('cart-drawer');
      if (d && d.classList.contains('active')) {
        if (typeof d.close === 'function') { try { d.close(); } catch (e) {} }
        d.classList.remove('active', 'animate');
      }
      document.body.classList.remove('overflow-hidden');
      var a = document.activeElement;
      if (a && a.id === 'upCart' && typeof a.blur === 'function') a.blur();
    }, 350);
  }
  (function hookUpcartClose() {
    var n = 0;
    (function tryHook() {
      if (typeof window.upcartSubscribeCartClosed === 'function') { try { window.upcartSubscribeCartClosed(releaseThemeLock); } catch (e) {} return; }
      if (++n < 40) setTimeout(tryHook, 250);
    })();
    if (window.MutationObserver) {
      var was = false;
      new MutationObserver(function () {
        var now = document.body.classList.contains('upcartPopupShow');
        if (was && !now) releaseThemeLock();
        was = now;
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  })();

  var busy = false;
  function addToCart(box) {
    if (busy) return;
    var pf = productForm(); if (!pf) return;
    var st = state(box); if (!st.id) return;
    busy = true;
    var btn = pf.el.querySelector('.product-form__submit');
    var spin = pf.el.querySelector('.loading__spinner');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    if (spin) spin.classList.remove('hidden');
    showError(pf, false);
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var upcart = hasUpcart();
    var body = { items: [{ id: st.id, quantity: st.qty }] };
    if (!upcart && cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { showError(pf, res.description || res.message || 'Hiba történt, próbáld újra.'); return; }
        if (upcart) {
          try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
          try { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); } catch (e) {}
          document.dispatchEvent(new CustomEvent('mvlpb:added', { detail: res }));
          return;
        }
        if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: st.id, cartData: res });
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') cart.renderContents(res);
        document.dispatchEvent(new CustomEvent('mvlpb:added', { detail: res }));
      })
      .catch(function (e) { console.error(e); showError(pf, 'Hiba történt, próbáld újra.'); })
      .finally(function () {
        busy = false;
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (spin) spin.classList.add('hidden');
      });
  }

  function mount(box) {
    if (box.dataset.mvlpbMounted) return true;
    var pf = productForm(); if (!pf) return false;
    var anchor = pf.el.closest('.product__info-container > *') || pf.el;
    anchor.parentNode.insertBefore(box, anchor);
    box.dataset.mvlpbMounted = '1';
    document.body.classList.add('mvlpb-on');

    box.addEventListener('click', function (e) {
      var card = e.target.closest('.mvlpb__card');
      if (card && !card.classList.contains('is-selected')) select(box, card);
    });
    box.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('mvlpb__card')) { e.preventDefault(); select(box, e.target); }
    });
    syncForm(box);
    return true;
  }

  /* a téma formjának beküldését (Kosárba gomb) a saját kosárba tételünkre irányítjuk */
  document.addEventListener('submit', function (e) {
    var box = qs('[data-mvlpb][data-mvlpb-mounted]'); if (!box) return;
    var pf = productForm(); if (!pf || e.target !== pf.form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (pf.el.querySelector('.product-form__submit[aria-disabled="true"]')) return;
    addToCart(box);
  }, true);

  /* záró ajánlat gombja: a beállított csomagot jelöli ki, a görgetés a #mvlp-buy horgonyra marad */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.mvlp-final a[href="#mvlp-buy"]'); if (!a) return;
    var box = qs('[data-mvlpb][data-mvlpb-mounted]'); if (!box) return;
    var card = qs('.mvlpb__card[data-n="' + (box.dataset.final || '3') + '"]', box);
    if (card && !card.classList.contains('is-selected')) select(box, card);
  });

  /* lebegő kosár-sáv */
  function sticky(box) {
    var bar = document.getElementById('mvlpb-sbar'); if (!bar || bar.dataset.on) return;
    bar.dataset.on = '1';
    document.body.appendChild(bar);
    var t = bar.querySelector('.mvlp-sbar__t'), s = bar.querySelector('.mvlp-sbar__s'), b = bar.querySelector('.mvlp-sbar__btn');
    function sync() {
      var c = qs('.mvlpb__card.is-selected', box); if (!c) return;
      t.textContent = c.dataset.title + ' · ' + c.dataset.total;
      s.textContent = c.dataset.sub || '';
    }
    var shown = false;
    function check() {
      var r = box.getBoundingClientRect();
      var v = r.bottom < 0;
      if (v !== shown) {
        shown = v; bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); b.tabIndex = v ? 0 : -1;
        /* amíg a sáv látszik: a lap alja térközt kap, a Klaviyo teaser a sáv fölé kerül (CSS) */
        document.body.classList.toggle('mvlpb-sbar-on', v);
      }
    }
    b.addEventListener('click', function () { addToCart(box); });
    document.addEventListener('mvlpb:change', sync);
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    sync(); check();
  }

  function init() {
    var box = qs('[data-mvlpb]'); if (!box) return false;
    if (!mount(box)) return false;
    sticky(box);
    return true;
  }
  function start() { if (!init()) { var n = 0, iv = setInterval(function () { if (init() || ++n > 40) clearInterval(iv); }, 250); } }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);

  /* galéria: a két glass chip csak az 1. dián látszik; ha másik dia aktív, a .mvlp-hero megkapja a mvlpd-not-first osztályt */
  document.addEventListener('scroll', function (e) {
    var s = e.target;
    if (!s || !s.classList || !s.classList.contains('mvlp-hero__slides')) return;
    var hero = s.closest('.mvlp-hero'); if (!hero) return;
    var i = Math.round(s.scrollLeft / Math.max(1, s.clientWidth));
    hero.classList.toggle('mvlpd-not-first', i !== 0);
  }, true);

  /* vélemény-kártyák fotói: a közös kód 160 px-es képet kér, a kártyán 120-136 px-ben jelenik meg, ezért élesebb, 480 px-es változat */
  function sharpReviewPhotos() {
    qsa('#mvlp-reviews img.mvlp-review__photo').forEach(function (im) {
      if (im.dataset.mvlpdSharp) return;
      im.dataset.mvlpdSharp = '1';
      im.removeAttribute('srcset'); im.removeAttribute('sizes');
      im.src = im.src.replace(/([?&])width=\d+/, '$1width=480');
    });
  }
  if (document.readyState !== 'loading') sharpReviewPhotos(); else document.addEventListener('DOMContentLoaded', sharpReviewPhotos);

  /* témaszerkesztő: a szekció újrarajzolása után újra beillesztjük */
  document.addEventListener('shopify:section:load', function () {
    var fresh = qsa('[data-mvlpb]').filter(function (b) { return !b.dataset.mvlpbMounted; })[0];
    if (!fresh) return;
    qsa('[data-mvlpb][data-mvlpb-mounted]').forEach(function (b) { b.remove(); });
    qsa('.mvlpb-sbar[data-on]').forEach(function (b) { b.remove(); });
    start();
  });
})();
